import React from 'react';
import { useTheme } from '../../Context/ThemeContext';
import { HiMoon, HiSun } from 'react-icons/hi';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <button
            onClick={toggleTheme}
            className="relative w-14 h-7 rounded-full bg-zinc-200 dark:bg-slate-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        >
            <div
                className={`absolute top-1 left-1 w-5 h-5 rounded-full bg-white dark:bg-slate-900 shadow-md transform transition-transform duration-300 flex items-center justify-center ${isDark ? 'translate-x-7' : 'translate-x-0'
                    }`}
            >
                {isDark ? (
                    <HiMoon className="w-3 h-3 text-purple-400" />
                ) : (
                    <HiSun className="w-3 h-3 text-yellow-500" />
                )}
            </div>
        </button>
    );
};

export default ThemeToggle;
